import React from 'react';
import PropTypes from 'prop-types';
import KpiSummary from '../../../commons/KpiSummary';

const PartnerAccessFrequencySummary = (props) => (
  <KpiSummary
    title="Access Frequency"
    isLoading={props.isLoading}
    currentValue={props.currentValue}
    previousValue={props.previousValue}
    standardDeviationValue={props.standardDeviationValue}
    formatter={props.formatter}
  />
);

PartnerAccessFrequencySummary.propTypes = {
  isLoading: PropTypes.bool,
  currentValue: PropTypes.number.isRequired,
  previousValue: PropTypes.number.isRequired,
  standardDeviationValue: PropTypes.number,
  formatter: PropTypes.func.isRequired,
};

PartnerAccessFrequencySummary.defaultProps = {
  isLoading: false,
};

export default PartnerAccessFrequencySummary;
